import {Component, HostListener} from '@angular/core';
import { OnInit }               from '@angular/core';
import { Input }                from '@angular/core';
//import { ViewContainerRef }   from '@angular/core';
import { ViewChild }            from '@angular/core';
import { PagetitleService }     from '../../../core/pagetitle/pagetitle.service';
import { FormGroup }            from '@angular/forms';
import { Observable }           from 'rxjs/Observable';

import { EncuestaService }      from '../../../services/encuesta/encuesta.service';
import { RespuestaService }     from '../../../services/respuesta/respuesta.service';
import { EmailEncuestaService } from '../../../services/email-encuesta/email-encuesta.service';
import { ConfigService }        from '../../../services/configuracion/config.service';
import { DynamicFormService }   from '../../../shared/ing-dynamic-form/dynamic-form.service';
import { Router }               from '@angular/router';
import {ActivatedRoute}         from '@angular/router';
import {Params}                 from '@angular/router';

import { IngInputBase }         from '../../../shared/ing-dynamic-form/inputs';
import { IngSelect }            from '../../../shared/ing-dynamic-form/inputs';
import { IngTextArea }          from '../../../shared/ing-dynamic-form/inputs';
import { IngSelectChild }       from '../../../shared/ing-dynamic-form/inputs';

const swal = require('sweetalert2');

@Component({
  selector: 'app-encuesta-responder',
  templateUrl: './encuesta-responder.component.html',
  styleUrls: ['./encuesta-responder.component.scss'],
  providers: [DynamicFormService]
})
export class EncuestaResponderComponent implements OnInit {
  loading          : boolean;
  ver              : boolean;
  iden             : string;
  encuesta         : any;
  imagen           : string;
  lstPreguntas     : Array<any>;
  lstCololes       : Array<any>;
  pasoActivo       : number;
  preguntaActiva   : any;
  inputs           : Array<any>;
  groups           : Array<any>;
  idEmailEncuesta  : any;

  formPregunta     : FormGroup;
  formNamePregunta : string;
  color            : string;

  paginaActiva     : Array<any>;
  ultimaPagina     : boolean;

  constructor(
    protected dfs                 :  DynamicFormService,
    public  configService         :  ConfigService,
    private activatedRoute        :  ActivatedRoute,
    private encuestaService       :  EncuestaService,
    private respuestaService      :  RespuestaService ,
    private emailEncuestaService  :  EmailEncuestaService
  ) {

    // QUITAMOS LA CLASE SMOOTH SCROLL SÓLO AL HACER ENCUESTAS YA QUE EN IE A ALGUNOS USUARIOS LES DA PROBLEMAS
    const body = document.getElementsByClassName('theme-imm')[0];
    body.className = 'theme-imm';

    this.loading           =  false;
    this.ver               =  false;

    this.encuesta      =  null;
    this.lstPreguntas  =  [];
    this.groups        =  [];
    this.pasoActivo    =  0;

    this.paginaActiva  = [];

    this.formPregunta      =  new FormGroup({});
    this.formNamePregunta  =  'formPregunta';

    this.color  =  '';
    this.llenarColores();
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    return false;
  }

  llenarColores() {
    this.lstCololes = [
      'bg-red-500', 'bg-pink-500', 'bg-purple-500', 'bg-deep-purple-500', 'bg-indigo-500',
      'bg-light-blue-800', 'bg-cyan-800', 'bg-teal-700', 'bg-light-green-800', 'bg-green-500',
      'bg-orange-800', 'bg-deep-orange-500', 'bg-brown-500', 'bg-blue-grey-500',
      'bg-brown-400', 'bg-blue-grey-600', 'bg-grey-600', 'bg-grey-800', 'bg-blue-grey-800',
      'bg-brown-700', 'bg-brown-300'
    ];
  }

  seleccionarColor() {
    const intColot = this.getRandomInt(0, (this.lstCololes.length - 1));

    this.color = this.lstCololes[intColot];
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  ngOnInit() {
    swal({
      title: 'Cargando cuestionario',
      text: 'Por favor espere un momento...'
    });
    swal.showLoading();

    this.encuesta        =  null;
    this.lstPreguntas    =  [];

    this.activatedRoute.params
    .flatMap((params: Params) => {
      this.iden = params['identificador'];

      return this.emailEncuestaService.verificarDisponibilidad(this.iden);
    })
    .flatMap(data => {
      this.idEmailEncuesta = parseInt(data['id'], 10);

      if (data !== false) {
        if (data['finalizada'] === 'N') {
          this.pasoActivo = parseInt(data['paso_activo'], 10);
          return this.encuestaService.getDatosEncuesta(data['encuesta_id']);
        } else {
          swal({
            title: 'Has finalizado el cuestionario',
            html: 'Gracias por dedicar tu tiempo a esta encuesta. Un saludo.', //  Si necesitas cualquier cosa no dudes en contactar con nosotros a través de <a href="mailto:imm@institutomm.com" target="_BLANK">imm@institutomm.com</a> o por teléfono <a href="tel:914266669" target="_BLANK">914266669</a>. Un saludo, el equipo de iMm
            type: 'success'
          });
          return [];
        }
      } else {
        swal('No se encontraron registros asociados', '', 'error');
        return [];
      }
    })
    .subscribe(
      data => {
        const misDatos        =  data;

        console.log('Mis datos => ', misDatos);

        this.encuesta       =  misDatos.encuesta[0];
        this.lstPreguntas   =  misDatos.lstPreguntas;
        this.preguntaActiva = this.lstPreguntas[this.pasoActivo];
        this.imagen = `${this.encuestaService.getApiUrl()}/imagen-proyecto/${this.encuesta.proyecto_id}`;
        console.log('Encuesta => ', this.encuesta);

        const idEstado = parseInt(this.encuesta.estEnc_id, 10);

        if (idEstado === 4) {
          if (misDatos.lstPreguntas.length > 0) {
            this.configurarPaginaActiva();

            setTimeout(() => {
              swal.close();
            }, 750);
          } else {
            swal('Error', 'El cuestionario no tiene preguntas asociadas', 'error');
          }
        } else {
          swal('Lo sentimos', 'El cuestionario no esta disponible.', 'info');
        }

        console.log('Formulario =>', this.paginaActiva);
      },
      error => {
        console.error(error);
      },
      () => console.info('')
    );
  }

  leaveWartning() {
    window.onbeforeunload = (event) => {
      const message = 'Important: Please click on \'Save\' button to leave this page.';
      if (typeof event === 'undefined') {
        event = window.event;
      }
      if (event) {
        event.returnValue = message;
      }

      setTimeout(() => {
        document.querySelector('li.warning-message').className = 'warning-message show';
      }, 500);

      return message;
    };
  }

  closeHelp() {
    document.querySelector('li.warning-message').className = 'warning-message';
  }

  cleanLeaveWarning() {
    // this.closeHelp();
    window.onbeforeunload = null;
  }

  configurarPaginaActiva() {
    const preguntasCopy = JSON.parse(JSON.stringify(this.lstPreguntas));

    this.cleanLeaveWarning();

    this.ver          = false;
    this.paginaActiva = preguntasCopy.splice(this.pasoActivo * this.encuesta.preguntas_pp, this.encuesta.preguntas_pp);
    this.ultimaPagina = this.pasoActivo === this.numeroPaginasCuestionario() - 1;

    this.paginaActiva.forEach(pregunta => this.pintarOpcionesRespuesta(pregunta));

    setTimeout(() => {
      this.ver = true;
    }, 200);
  }

  pintarOpcionesRespuesta(pregunta) {
    switch (pregunta.pregunta.tr_tipo) {
      case 'RadioButton':
        this.createRadioButtonForm(pregunta);
        break;
      case 'TextArea':
        this.createTextAreaForm(pregunta);
        break;
      case 'CheckBox':
        this.createCheckBoxForm(pregunta);
        break;
      case 'InputText':
        this.createInputTextForm(pregunta, 'text');
        break;
      case 'InputNumber':
        this.createInputTextForm(pregunta, 'number');
        break;
      case 'Select':
        this.createSelectForm(pregunta);
        break;
    }

    const form: FormGroup = pregunta.formPregunta;

    form.valueChanges.subscribe(data => {
      if (!form.pristine) {
        // this.leaveWartning();
      }
    });
  }

  createRadioButtonForm(pregunta) {
    const inputs = [];
    pregunta.formPregunta = new FormGroup({});

    pregunta.opcRespuesta.forEach(opc => {
      inputs.push(new IngInputBase<String>({
        key: ['opc', opc.pregunta_id].join('_'),
        order: inputs.length,
        value: ['opc', opc.id].join('_'),
        label: opc.descripcion,
        required: false,
        controlType: 'ing-radio-button',
        classContainer: 'col-md-12'
      }));
    });

    pregunta.formPregunta = this.dfs.toGroup(inputs);
    pregunta.formPregunta.controls[['opc', pregunta.pregunta.id].join('_')].setValue(null);
    pregunta.inputs = inputs;
  }

  createTextAreaForm(pregunta) {
    const inputs = [];
    pregunta.formPregunta = new FormGroup({});

    inputs.push(new IngTextArea({
        key: ['opc', pregunta.opcRespuesta[0].id].join('_'),
        order: inputs.length,
        value: '',
        label: pregunta.opcRespuesta[0].descripcion,
        required: false,
        controlType: 'ing-textarea',
        placeHolder: '',
        classContainer: 'col-md-12'
    }));

    pregunta.formPregunta = this.dfs.toGroup(inputs);
    pregunta.inputs = inputs;
  }

  createCheckBoxForm(pregunta) {
    const inputs = [];
    pregunta.formPregunta = new FormGroup({});

    pregunta.opcRespuesta.forEach(opc => {
      inputs.push(new IngInputBase<Boolean>({
          key: ['opc', opc.pregunta_id, opc.id].join('_'),
          order: inputs.length,
          value: false,
          label: opc.descripcion,
          required: false,
          controlType: 'ing-checkbox',
          placeHolder: '',
          classContainer: 'col-md-12'
      }));
    });

    pregunta.formPregunta = this.dfs.toGroup(inputs);
    pregunta.inputs = inputs;
  }

  createSelectForm(pregunta) {
    console.log('PREGUNTA: ', pregunta);
    const inputs = [];
    pregunta.formPregunta = new FormGroup({});

    const select = new IngSelect({
      key: ['opc', pregunta.pregunta.id].join('_'),
      order: inputs.length,
      label: '',
      required: pregunta.pregunta.requerido,
      controlType: 'ing-select',
      classContainer: 'col-md-12',
      placeHolder: '[Seleccione una opción]'
    });

    const optionsSelect = [];
    pregunta.opcRespuesta.forEach(opc => {
      optionsSelect.push({
        id: opc.id,
        text: opc.descripcion
      });
    });
    select.options = optionsSelect;

    inputs.push(select);

    pregunta.formPregunta = this.dfs.toGroup(inputs);
    pregunta.formPregunta.controls[['opc', pregunta.pregunta.id].join('_')].setValue(null);
    pregunta.inputs = inputs;
  }

  createInputTextForm(pregunta, tipo: string) {
    const inputs = [];

    pregunta.formPregunta = new FormGroup({});
    inputs.push(new IngInputBase({
      key: ['opc', pregunta.opcRespuesta[0].id].join('_'),
      order: inputs.length,
      value: '',
      label: pregunta.opcRespuesta[0].descripcion,
      required: false,
      controlType: tipo,
      placeHolder: '',
      classContainer: 'col-md-12'
    }));

    pregunta.formPregunta = this.dfs.toGroup(inputs);
    pregunta.inputs = inputs;
  }

  siguientePagina() {
    const totalPaginas = this.numeroPaginasCuestionario() - 1;

    if (this.pasoActivo <= totalPaginas) {
      console.log('PasoActivo   => ', this.pasoActivo);
      console.log('TotalPaginas => ', totalPaginas);
      console.log('UltimaPagina => ', this.ultimaPagina);

      const respuestas = [];

      try {
        this.paginaActiva.forEach(pregunta => respuestas.push(this.procesarPregunta(pregunta)));

        this.guardarRespuesta(respuestas);
      } catch (ex) {
        console.log(ex);

        swal({
          html: ex.toString(),
          type: 'error',
          confirmButtonText: 'Aceptar'
        });
      }
    }
  }

  numeroPaginasCuestionario(): number {
    return Math.floor(
      this.lstPreguntas.length / this.encuesta.preguntas_pp
    ) + (
        this.lstPreguntas.length % this.encuesta.preguntas_pp === 0 ? 0 : 1
    );
  }
  // siguientePregunta(){
  //   let form = this.formPregunta.value;

  //   if(this.pasoActivo  < (this.lstPreguntas.length -1)){
  //     this.procesarPregunta();
  //   }
  // }


  // anteriorPregunta() {
  //   if(this.pasoActivo  > 0) {
  //     this.pasoActivo --;
  //     this.preguntaActiva = this.lstPreguntas[this.pasoActivo];
  //     // this.pintarOpcionesRespuesta();
  //   }
  // }

  // ultimaPregunta(){
  //   this.procesarPregunta();
  // }


  procesarPregunta(pregunta) {
    let   respuesta    = {};
    const tipoOpciones = pregunta.pregunta.tr_tipo;

    if (tipoOpciones === 'TextArea' || tipoOpciones === 'InputText' || tipoOpciones === 'InputNumber') {
      respuesta = this.estructurarTextOArea(pregunta, tipoOpciones);
    } else if (tipoOpciones === 'CheckBox' || tipoOpciones === 'RadioButton') {
      respuesta = this.estructurarCheckAndBox(pregunta, tipoOpciones);
    } else if (tipoOpciones === 'Select') {
      respuesta = this.estructurarSelect(pregunta, tipoOpciones);
    } else {
      swal('El tipo de input a procesar No se encuestra parametrizado', '', 'error');
    }

    return respuesta;
  }

  estructurarTextOArea(pregunta, tipoOpcion): any {
    const form = pregunta.formPregunta.value;

    let   tieneContenido    = false;
    const nuevoPasoActivo   = this.pasoActivo + 1;
    const preguntaRequerida = pregunta.pregunta.requerido === 'true' ? true : false;
    const respuesta         = {
      tr_tipo             :  tipoOpcion,
      paso_activo         :  nuevoPasoActivo,
      emailencuesta_id    :  this.idEmailEncuesta,
      tamanioLista        : this.numeroPaginasCuestionario()
    };

    const key           = ['opc', pregunta.opcRespuesta[0].id].join('_');
    const idOpRespuesta = pregunta.opcRespuesta[0].id;
    let valor           = form[key];

    valor = valor.trim();
    tieneContenido = valor !== '' ? true : false;

    respuesta['opcionrespuesta_id']    =    idOpRespuesta;
    respuesta['respuesta']             =    valor;

    if (preguntaRequerida === true && tieneContenido === false){
      throw [
        'La pregunta',
        `<b>${pregunta.pregunta.descripcion_pregunta.toUpperCase()}</b>`,
        'es obligatoria'
      ].join(' ');
    }

    return respuesta;
  }

  estructurarCheckAndBox(pregunta, tipoOpcion): any {
    const form = pregunta.formPregunta.value;

    const nuevoPasoActivo = this.pasoActivo + 1;

    const respuesta = {
      tr_tipo             :  tipoOpcion,
      paso_activo         :  nuevoPasoActivo,
      emailencuesta_id    :  this.idEmailEncuesta,
      tamanioLista        :  this.numeroPaginasCuestionario()
    };

    const lstRespuestas      =  [];
    let   tieneSeleccionado  =  false;
    const preguntaRequerida  =  pregunta.pregunta.requerido === 'true' ? true : false;

    if (tipoOpcion === 'CheckBox') {
      for (const propiedad in form) {
        if (form.hasOwnProperty(propiedad)) {
          const idOpRespuesta = propiedad.split('_')[2];
          const miCheck       = {
            emailencuesta_id    :  this.idEmailEncuesta,
            opcionrespuesta_id  :  idOpRespuesta,
            respuesta           :  form[propiedad].toString()
          };

          lstRespuestas.push(miCheck);

          if (preguntaRequerida === true && tieneSeleccionado === false) {
            if (form[propiedad] === true) {
              tieneSeleccionado = form[propiedad];
            }
          }
        }
      }
    } else if (tipoOpcion === 'RadioButton') {
        let seleccionado;

        for (const propiedad in form) {
          if (form.hasOwnProperty(propiedad)) {
            seleccionado = form[propiedad];
            break;
          }
        }

        tieneSeleccionado = seleccionado !== false;

        const idOpRespuesta = seleccionado !== false ? seleccionado.split('_')[1] : '';

        pregunta.opcRespuesta.forEach(opc => {
          const respuestaP = opc.id === idOpRespuesta ? 'true' : 'false';

          lstRespuestas.push({
            emailencuesta_id: this.idEmailEncuesta,
            opcionrespuesta_id: opc.id,
            respuesta: respuestaP
          });
        });
    }

    respuesta['lstRespuestas'] = lstRespuestas;

    if (preguntaRequerida === true && tieneSeleccionado === false){
      throw [
        'La pregunta',
        `<b>${pregunta.pregunta.descripcion_pregunta.toUpperCase()}</b>`,
        'es obligatoria'
      ].join(' ');
    }

    return respuesta;
  }

  estructurarSelect(pregunta, tipoOpcion): any {
    console.log('PREGUNTA: ', pregunta);

    let   tieneContenido;
    const nuevoPasoActivo   = this.pasoActivo + 1;
    const preguntaRequerida = pregunta.pregunta.requerido === 'true';
    const respuesta         = {
      tr_tipo             :  tipoOpcion,
      paso_activo         :  nuevoPasoActivo,
      emailencuesta_id    :  this.idEmailEncuesta,
      tamanioLista        : this.numeroPaginasCuestionario()
    };

    const idOpRespuesta = pregunta.inputs[0].selectedOptions;
    console.log('idOpRespuesta: ', idOpRespuesta);
    let valor           = idOpRespuesta.length > 0 ? pregunta.opcRespuesta.filter( item => item.id === idOpRespuesta) : [];
    valor = valor.length > 0 ? valor[0].descripcion : null;
    console.log('valor: ', valor);

    tieneContenido = !!valor;

    console.log(idOpRespuesta, valor);
    console.log(tieneContenido);

    respuesta['opcionrespuesta_id']    =    idOpRespuesta;
    respuesta['respuesta']             =    valor;

    if (preguntaRequerida === true && tieneContenido === false) {
      throw [
        'La pregunta',
        `<b>${pregunta.pregunta.descripcion_pregunta.toUpperCase()}</b>`,
        'es obligatoria'
      ].join(' ');
    }

    return respuesta;
  }

  guardarRespuesta(respuestas: Array<any>) {
    swal({
      title: 'Guardando respuestas',
      text: 'Por favor espera un momento mientras procesamos su información.',
      type: 'info',
      showLoading: true,
      confirmButtonText: 'Aceptar'
    });

    swal.disableButtons();
    swal.showLoading();

    this.respuestaService.save(respuestas)
    .subscribe(
      data => {
        const totalPaginas = this.numeroPaginasCuestionario() - 1;

        this.pasoActivo++;

        if (this.pasoActivo <= totalPaginas) {
          this.configurarPaginaActiva();
          swal.closeModal();
        } else {
          this.ver  =  false;
          swal({
            title: 'Has finalizado el cuestionario',
            html: 'Gracias por dedicar tu tiempo a esta encuesta. Un saludo.', // Si necesitas cualquier cosa no dudes en contactar con nosotros a través de <a href="mailto:imm@institutomm.com" target="_BLANK">imm@institutomm.com</a> o por teléfono <a href="tel:914266669" target="_BLANK">914266669</a>. Un saludo, el equipo de iMm
            type: 'success'
          });
        }
      },
      error => {
        console.error(error);
        swal(
          'Error',
          'Ha ocurrido un error al guardar sus respuestas',
          'error'
        );
      }
    );
  }

  cerrar() {
    if (!!window && !!window.close) {
      window.close();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/encuesta/encuesta-responder/encuesta-responder.component.ts